import SideBar from "./SideBar";
import { Navigate } from "react-router-dom";
import PaymentArea from "./PaymentArea";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import { useEffect } from "react";

const HotelPaymentArea = () => {
    const { hotelSelection, guestsInformation } = useHotelContext();
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);
    if (!hotelSelection || !guestsInformation) {
        return <Navigate to={"/hotel-search"} />;
    }

    return (
        <>
            <section id="tour_booking_submission" className="section_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mb-4">
                            <PaymentArea />
                        </div>
                        <div className="col-lg-4">
                            <SideBar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HotelPaymentArea;
